module.exports = __webpack_public_path__ + "static/media/Poppins-MediumItalic.4e8cea18.ttf";